import EntityNotesPanel from './EntityNotesPanel';

export default EntityNotesPanel;
